export default "__VITE_ASSET__cfc5b6d4__"